export const GET_HOOK_MAP_URL = "https://demo.trackhooki.app/api/get-hook-map";
export const TRIGGER_META_EVENT_URL =
  "https://demo.trackhooki.app/api/trigger-meta-event";
export const TRIGGER_BREVO_CONTACT =
  "https://demo.trackhooki.app/api/trigger-brevo-contact";
